<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        style="margin-right: 10px; width: 200px"
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        v-if="userInfo.park_id == 0"
        @change="screenPark"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        style="margin-right: 10px; width: 200px"
        filterable
        v-model="screen.manufacturer_num"
        placeholder="请选择硬件厂商"
        :disabled="screen.park_id == ''"
      >
        <el-option
          :label="item.name"
          :value="item.unique_num"
          v-for="(item, index) in manufacturerList"
          :key="index"
          >{{ item.name }}</el-option
        >
      </el-select>
      <!-- <el-select
        filterable
        v-model="screen.organ_id"
        placeholder="请选择所属组织"
        :disabled="screen.park_id == '' && screen.manufacturer_num"
      >
        <el-option
          :label="item.name"
          :value="item.unique_num"
          v-for="(item, index) in organList"
          :key="index"
          >{{ item.name }}</el-option
        >
      </el-select> -->
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.like"
        placeholder="请输入手机号或昵称，模糊搜索"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 20px">
      <!-- <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        v-if="roles.includes('/device/add_organ')"
        >添加硬件人员</el-button
      > -->
      <el-button
        size="medium"
        type="danger"
        @click="delUser()"
        v-if="roles.includes('/device/del_user')"
        >删除硬件人员</el-button
      >
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55" :selectable="selectable">
      </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="人员名称" width="200">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="center" width="200">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.phone }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.park">
            {{ scope.row.park.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="厂商唯一标识" align="center" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.manufacturer_num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属组织" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.organ">
            {{ scope.row.organ.name }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/device/organ_info')"
            >查看门禁设备列表</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/device/edit_organ')"
            >编辑</el-button
          > -->
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/device/del_user')"
            >删除</el-button
          >
          <!-- <div style="margin-top: 10px">
            <el-button
              size="mini"
              type="primary"
              @click="devices(scope.row)"
              v-if="roles.includes('/device/select_devices')"
              >开通门禁服务</el-button
            >
            <el-button
              style="background: #00b0ff; border: #00b0ff"
              size="mini"
              type="primary"
              @click="users(scope.row)"
              v-if="roles.includes('/device/user_lists')"
              >组织人员</el-button
            >
          </div> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      title="硬件组织人员"
      :visible.sync="usersDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="600px"
    >
      <div style="padding: 10px">
        <el-table :data="usersData">
          <el-table-column property="name" label="设备名称"></el-table-column>
          <el-table-column property="unique_num" label="设备唯一标识">
            <template slot-scope="scope">
              <div class="line2" v-if="scope.row.unique_num">
                {{ scope.row.unique_num }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  organLists,
  addOrgan,
  editOrgan,
  delUser,
  organInfo,
  selectDevices,
  userLists,
  addUsers,
  get_manufacturers,
  get_all_devices,
  get_device_users,
  myDevices,
} from "@/api/device";
import { openPark } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      weekLists: [
        {
          title: "星期一",
          checked: true,
        },
        {
          title: "星期二",
          checked: true,
        },
        {
          title: "星期三",
          checked: true,
        },
        {
          title: "星期四",
          checked: true,
        },
        {
          title: "星期五",
          checked: true,
        },
        {
          title: "星期六",
          checked: true,
        },
        {
          title: "星期日",
          checked: true,
        },
      ],
      timestamp: "yyyy-MM-dd",
      dialogFormVisible: false,
      devicesForm: {},
      devicesList: [],
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加硬件组织",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        manufacturer_num: "",
        organ_id: "",
        like: "",
      },
      ruleForm: {
        name: "",
        park_id: "",
        manufacturer_num: "",
        type: 1,
        source_id: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入硬件组织名称", trigger: "blur" },
        ],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        manufacturer_num: [
          { required: true, message: "请选择硬件厂商", trigger: "change" },
        ],
        // status: [{ required: true, message: "请选择状态", trigger: "change" }],
        source_id: [
          { required: true, message: "请选择权限", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择组织类型", trigger: "change" },
        ],
      },
      multipleSelection: [],
      czType: "",
      parkList: [],
      sourceList: [],
      manufacturerList: [],

      usersFormVisible: false,
      usersForm: {},
      usersDrawer: false,
      usersData: [],
      deviceList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getpark();
  },
  methods: {
    // 搜索园区选择
    screenPark(e) {
      this.getManufacturer(e);
    },

    // 选择硬件厂商
    sourceChange(e) {
      this.sourceList.forEach((item) => {
        if (e == item.id) {
          this.ruleForm.name = item.name;
        }
      });
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        manufacturer_num: "",
        organ_id: "",
        like: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    selectable(row, index) {
      if (row.id != this.userInfo.id) {
        return true;
      }
    },
    parkChange(e) {
      this.ruleForm.manufacturer_num = "";
      this.ruleForm.name = "";
      // this.ruleForm.type = "";
      this.getManufacturer(e);
    },
    getManufacturer(parkId) {
      get_manufacturers({ park_id: parkId }).then((res) => {
        this.manufacturerList = res.data;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑硬件组织";
      this.getManufacturer(val.park_id);
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id

      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);

      this.drawer = true;
    },
     getInfo(id, type,organ_type) {
      var that = this;
      organInfo({ id: id,organ_type:organ_type }).then((res) => {
        if (type == "menJin") {
          this.devicesForm.deviceGuids = res.data.info.all_service;
          this.devicesForm.manufacturer_num = res.data.info.manufacturer_num;
          this.devicesForm.organ_type = res.data.info.organ_type;
          this.devicesForm.deviceTikongs = [];
          if (res.data.info.all_tikongs) {
            res.data.info.all_tikongs.forEach((item, index) => {
              this.devicesForm.deviceTikongs.push({
                floors: item.floor.split(","),
                deviceGuids: item.devguid,
              });
              that.tkChange(item.devguid, index, "info");
            });
          }

          if (res.data.info.config) {
            let time = [];
            time[0] = res.data.info.config.service_start_time;
            time[1] = res.data.info.config.service_end_time;
            this.$set(this.devicesForm, "time", time);
            this.$set(
              this.devicesForm,
              "service_start_date",
              res.data.info.config.service_start_date
            );
            this.$set(
              this.devicesForm,
              "service_end_date",
              res.data.info.config.service_end_date
            );
            this.devicesForm.service_week = res.data.info.config.service_week;
          }
          // this.getSource();
          // this.devicesForm.service_end_time = res.data.info.config ? res.data.info.config.service_end_time : '';
          // this.devicesForm.service_start_time = res.data.info.config? res.data.info.config.service_start_time : '';
          // this.devicesForm.service_week = res.data.info.config? res.data.info.config.service_week : '1111111';
        } else {
          this.ruleForm = {
            id: res.data.info.id,
            park_id: res.data.info.park_id,
            manufacturer_num: res.data.info.manufacturer_num,
            organ_type: res.data.info.organ_type,
            source_id: res.data.info.source_id,
            name: res.data.info.name,
          };

          if (res.data.info.organ_type == 3) {
            this.ruleForm.ld_id = "";
            // this.getSource(res.data.info.organ_type,'change');
          }
        }
        this.getSource(res.data.info.organ_type, "radio");
        // this.getSource(res.data.info.type);
      });
    },
    // 查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "拥有的门禁设备列表";
      setTimeout(() => {
        // this.getInfo(val.id);
        this.getMyDevices(val.id);
      }, 500);
      // this.getInfo(val.id);

      this.usersDrawer = true;
    },
    getMyDevices(id) {
      let data = {
        id: id,
      };
      myDevices(data).then((res) => {
        this.usersData = res.data;
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          delUser({ ids: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          // this.$nextTick(() => {
          //   this.$refs.ruleForm.clearValidate();
          // });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getpark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    delUser() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个组织");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          delUser({ ids: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      userLists(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    display: inline-block;
  }
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
</style>
